The date & time the `PositionProfile` was considered as successfully updated inside of SEEK's internal systems.

This field has weak ordering guarantees, so it should not be used as a pagination argument.
